import React, { useState, useEffect, useMemo } from "react";
import {
  Form,
  DatePicker,
  Row,
  Col,
  Select,
  Input,
  Button,
  Table,
  message,
} from "antd";
import {
  getTaxEnterpriseList,
  getRelevanceCompany,
  getPersonalTaxMonthList,
  exportPersonalTaxMonthList,
} from "../../../../api/api";
import moment from "moment";

const { Option } = Select;
const { RangePicker } = DatePicker;
const itemStyle = { width: "300px", marginRight: "15px" };
const labelStyleObj = {
  labelCol: { span: 7 },
  wrapperCol: { span: 17 },
};

const Monthly = () => {
  const [form] = Form.useForm();
  const currentMonth = moment().format("YYYY-MM");
  const [loading, setLoading] = useState(false);
  const [taxEnterpriseCodeList, settaxEnterpriseCodeList] = useState([]);
  const [companyCodeList, setcompanyCodeList] = useState([]);

  // 关键：新增 allData 存储全量数据
  const [allData, setAllData] = useState([]);

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    showQuickJumper: true,
    showTotal: (total) => `共 ${total} 条`,
  });

  useEffect(() => {
    getTaxEnterpriseListall();
    getRelevanceCompanyall();
    // 组件挂载时加载数据
    getPersonalTaxMonthListall();
  }, []);

  // 获取所有结算企业
  const getTaxEnterpriseListall = async () => {
    const res = await getTaxEnterpriseList();
    if (res.data.success) {
      settaxEnterpriseCodeList(res.data.data);
    }
  };

  // 获取所有企业
  const getRelevanceCompanyall = async () => {
    const res = await getRelevanceCompany();
    if (res) setcompanyCodeList(res);
  };

  // 获取全量数据
  const getPersonalTaxMonthListall = async () => {
    const { companyCodeList, taxEnterpriseCodeList, keyword, rangeDate } =
      form.getFieldsValue();

    // 校验 rangeDate 是否为空
    if (!rangeDate) {
      message.error("请选择月份");
      return;
    }

    setLoading(true);
    try {
      const params = {
        companyCodeList,
        taxEnterpriseCodeList,
        keyword,
        beginTime: moment(rangeDate[0]).format("YYYY-MM"),
        endTime: moment(rangeDate[1]).format("YYYY-MM"),
        // 接口可能忽略这些参数，但仍保留以兼容原有接口
        pageNum: 1,
        pageSize: 9999, // 设置一个足够大的数确保获取全量数据
      };

      const { data: res } = await getPersonalTaxMonthList(params);
      if (!res.success) {
        message.error(res.retMsg);
        return;
      }

      // 假设接口返回 res.data 是数组
      const fullData = Array.isArray(res.data) ? res.data : [];

      setAllData(fullData); // 存储全量数据

      // 重置分页到第一页
      setPagination((prev) => ({
        ...prev,
        current: 1,
        total: fullData.length,
      }));
    } catch (error) {
      message.error(error.message || "获取数据失败");
    } finally {
      setLoading(false);
    }
  };

  // 关键：使用 useMemo 计算当前页数据
  const currentPageData = useMemo(() => {
    const { current, pageSize } = pagination;
    const startIndex = (current - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    return allData.slice(startIndex, endIndex);
  }, [allData, pagination]);

  // 分页变化处理（仅更新状态，不调用接口）
  const handleTableChange = (newPagination) => {
    setPagination({
      ...pagination,
      current: newPagination.current,
      pageSize: newPagination.pageSize,
    });
  };

  // 重置
  const resetForm = () => {
    form.resetFields();
    // 重置后重新加载数据
    getPersonalTaxMonthListall();
  };

  // 月份变化
  const handlerChange = (dates, dateStrings) => {
    if (dates === null) {
      form.setFieldsValue({ rangeDate: null });
    }
  };

  // 查询
  const submit = () => {
    // 查询时重置到第一页
    setPagination((prev) => ({ ...prev, current: 1 }));
    getPersonalTaxMonthListall();
  };

  // 导出
  const exportExcel = () => {
    // 导出功能可以使用 allData 全量数据
    try {
      const { companyCodeList, taxEnterpriseCodeList, keywordq, rangeDate } =
        form.getFieldsValue();
      const params = {
        companyCodeList,
        taxEnterpriseCodeList,
        keywordq,
        beginTime: rangeDate ? moment(rangeDate[0]).format("YYYY-MM") : "",
        endTime: rangeDate ? moment(rangeDate[1]).format("YYYY-MM") : "",
      };
      exportPersonalTaxMonthList(params);
    } catch (error) {
      message.error(error);
    }
  };

  // 列表字段
  const tableColumns = [
    {
      title: "月份",
      dataIndex: "paymentTime",
      key: "paymentTime",
      width: 180,
      align: "center",
    },
    {
      title: "结算企业",
      dataIndex: "taxEnterpriseName",
      key: "taxEnterpriseName",
      width: 300,
      align: "center",
    },
    {
      title: "企业名称",
      dataIndex: "companyName",
      key: "companyName",
      width: 280,
      align: "center",
    },
    {
      title: "姓名",
      dataIndex: "name",
      key: "name",
      align: "center",
    },
    {
      title: "身份证号",
      dataIndex: "idNumber",
      key: "idNumber",
      width: 180,
      align: "center",
    },
    {
      title: "当月应发佣金",
      dataIndex: "amount",
      key: "amount",
      align: "center",
    },
    {
      title: "当月应纳税所得额",
      dataIndex: "paymentTaxAmount",
      key: "paymentTaxAmount",
      align: "center",
    },
    {
      title: "当月个税",
      dataIndex: "tax",
      key: "tax",
      align: "center",
    },
    {
      title: "当月实发佣金",
      dataIndex: "actualAmount",
      key: "actualAmount",
      align: "center",
    },
    {
      title: "当月实发合计",
      dataIndex: "billAmount",
      key: "billAmount",
      align: "center",
    },
    {
      title: "实发差异",
      dataIndex: "diffAmount",
      key: "diffAmount",
      align: "center",
    },
  ];

  return (
    <div>
      <Form
        form={form}
        {...labelStyleObj}
        labelAlign="left"
        initialValues={{
          rangeDate: [moment(currentMonth), moment(currentMonth)],
        }}
      >
        <Row>
          <Form.Item label="月份" name="rangeDate">
            <RangePicker
              allowClear
              format={"YYYY-MM"}
              onChange={handlerChange}
              picker="month"
            />
          </Form.Item>
        </Row>
        <Row>
          <Form.Item label="企业名称" name="companyCodeList" style={itemStyle}>
            <Select
              allowClear
              placeholder="全部"
              showSearch
              optionFilterProp="children"
            >
              {companyCodeList.map((e) => (
                <Option key={e.companyCode} value={e.companyCode}>
                  {e.companyName}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="结算企业"
            name="taxEnterpriseCodeList"
            style={itemStyle}
          >
            <Select
              allowClear
              placeholder="全部"
              showSearch
              optionFilterProp="children"
            >
              {taxEnterpriseCodeList.map((e) => (
                <Option key={e.code} value={e.code}>
                  {e.enterpriseName}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item style={itemStyle} name="keyword" label="关键字">
            <Input placeholder="姓名丨身份证号丨手机号 | 所在城市" />
          </Form.Item>
        </Row>
        <Row>
          <Col span={24} style={{ textAlign: "right" }}>
            <Button
              type="primary"
              onClick={submit}
              style={{ marginRight: "15px" }}
            >
              查询
            </Button>
            <Button onClick={resetForm}>重置</Button>
            <Button
              type="primary"
              style={{ marginLeft: "15px" }}
              onClick={exportExcel}
            >
              导出
            </Button>
          </Col>
        </Row>
      </Form>
      <Table
        columns={tableColumns}
        dataSource={currentPageData} // 关键：使用计算后的当前页数据
        pagination={pagination}
        onChange={handleTableChange}
        bordered
        size="middle"
        loading={loading}
        rowKey={(record) => record.id || record.key} // 确保有唯一 key
      />
    </div>
  );
};

export default Monthly;
